import { render, staticRenderFns } from "./NotificationTray.vue?vue&type=template&id=40e4f7ae&"
import script from "./NotificationTray.vue?vue&type=script&lang=js&"
export * from "./NotificationTray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports